import * as fieldActions from '../../Common/actions/Field';
import * as collectionActions from '../../Common/actions/Collection';
//import * as itemTypes from '../../../constants/ItemTypes';
import {getLocalizedText, texts} from '../../../../constants/TextConst';

export function changeTitle(field, newTitle, cancelCallback) {
    fieldActions.changeTitle(
        field,
        newTitle,
        cancelCallback,
        getLocalizedText(texts.printFormatErrText)
    );
}

export function cancelTitleChange(field) {
    fieldActions.cancelTitleChange(field);
}

export function isHideDisabled(field) {
    return field.needed && field.mayFieldShow;
}

export function deleteActiveReportField(field) {
    // TODO: Insted of this function we should make a callbacl from GWT and reload the list
    const {screen} = field;
    if (!field.isClone) {
        screen.setLoading(true);
        field.deleteDesignField();
        screen.resetSelected();
    }
    collectionActions.deleteField(field);
}

export function restoreActiveField(field) {
    const {screen} = field;
    screen.setLoading(true);
    field.restoreDesignField();
    screen.setActive(null);
}

export function cloneActiveField(field) {
    //   We need to deep clone the object in order to create an
    //   independent new observable object with the same proparties as the original one.

    const {screen} = field;

    // find last field in the recursie structure
    const lastField = findLastField(screen);
    let fieldName = lastField.name;

    const newField = screen.createNewField(field, screen);
    newField.pos = '0';
    newField.isClone = true;

    newField.srvIndex = newField.name = ++fieldName + '';
    newField.title = prepareClonedName(screen.collection.fields, screen.active.title);
    newField.changed = true;

    screen.lastCopy = newField;

    newField.setCollection(field, true);

    screen.collection.addField(newField);
    screen.setActive(newField);
    screen.setSelected(newField);
    collectionActions.moveToEnd(newField);
    newField.setChanging(true);
    field.changed = false;
}

function prepareClonedName(fields, currentTitle) {
    const newTitle = `${getLocalizedText(texts.copyOfLabel)} ${currentTitle}`;
    for (let i = 0; i < fields.length; i++) {
        if (fields[i].title === newTitle) {
            return prepareClonedName(fields, newTitle);
        }
    }

    return newTitle;
}

function findLastField(screen) {
    const {collection} = screen;
    const {fields} = collection;
    if (fields && fields.length) {
        return findLastField(fields[fields.length - 1]);
    } else {
        return screen;
    }
}
